/**
 * Plan de marquage GA4 / GTM — events dataLayer.
 */
(function () {
  

  const config = window.dmTracking || {};

  function push() {
    window.dataLayer = window.dataLayer || [];
    // eslint-disable-next-line prefer-rest-params, prefer-spread
    window.dataLayer.push.apply(window.dataLayer, arguments);
  }

  function pushEvent(payload) {
    push(payload);
  }

  function pushEcommerce(eventName, ecommerce) {
    push({ ecommerce: null });
    push({
      event: eventName,
      ecommerce: ecommerce,
    });
  }

  function getItemFromElement(el) {
    if (!el) return null;
    const raw = el.getAttribute('data-tracking-item');
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function resolveFormMapping(detail) {
    const formId = detail && detail.contactFormId ? Number(detail.contactFormId) : null;
    if (formId && config.knownFormIds && config.knownFormIds[formId]) {
      return config.knownFormIds[formId];
    }
    return config.formContext || null;
  }

  function fireFormEvents(mapping) {
    if (!mapping || !mapping.events) return;
    mapping.events.forEach((eventName) => {
      const payload = { event: eventName };
      if (eventName === 'generate_lead' && mapping.lead_source) {
        payload.lead_source = mapping.lead_source;
      }
      if (eventName === 'property_match_request' && mapping.lead_source) {
        payload.lead_source = mapping.lead_source;
      }
      pushEvent(payload);
    });
  }

  /* ——— Page load ecommerce ——— */
  function trackViewItemList() {
    if (!config.isPropertyArchive || !config.archiveItems || !config.archiveItems.length) {
      return;
    }
    const listMeta = config.listMeta || {};
    pushEcommerce('view_item_list', {
      item_list_id: listMeta.item_list_id || '',
      item_list_name: listMeta.item_list_name || '',
      items: config.archiveItems,
    });
  }

  function trackViewItem() {
    if (!config.isSingleProperty || !config.viewItem) return;
    pushEcommerce('view_item', config.viewItem);
  }

  function trackAlertUpdated() {
    if (!config.alertUpdated) return;
    fireFormEvents({
      events: ['generate_lead', 'alert_subscription'],
      lead_source: "Formulaire de création d'alerte",
    });
  }

  /* ——— Clics globaux ——— */
  function bindGlobalClicks() {
    document.addEventListener(
      'click',
      (event) => {
        const target = event.target.closest('a, button, label, .offre-item, .bien-item');
        if (!target) return;

        // Header CTA "rencontrons nous"
        if (target.closest('.open-contact')) {
          pushEvent({ event: 'header_cta' });
        }

        // tel:
        const telLink = target.closest('a[href^="tel:"]');
        if (telLink) {
          pushEvent({ event: 'contact_tel' });
        }

        // mailto: (hors pictos de partage → event share)
        const mailLink = target.closest('a[href^="mailto:"]');
        if (mailLink && !mailLink.closest('.social-share')) {
          pushEvent({ event: 'contact_mailto' });
        }

        // Share
        const shareLink = target.closest('.social-share a');
        if (shareLink) {
          const method =
            shareLink.getAttribute('data-share-method') ||
            (shareLink.getAttribute('title') || '').replace(/^Partager sur\s+/i, '') ||
            'unknown';
          const shareItem = config.shareItem || config.readPost || {};
          pushEvent({
            event: 'share',
            method: method,
            content_type: shareItem.content_type || 'post',
            item_id: shareItem.item_id,
          });
        }

        // CTA biens vendus
        const soldCta = target.closest('a.biens-vendus__cta, a[data-tracking="cta_sold_properties"]');
        if (soldCta) {
          pushEvent({ event: 'cta_sold_properties' });
        }

        // Floating CTA fiche bien
        if (target.closest('.single-property__recap__contact a')) {
          pushEvent({ event: 'property_contact_floating_cta' });
        }

        // Open search form
        if (
          target.matches('.archive-property__form__filters__section > label') ||
          target.closest('.archive-property__form__filters__section > label')
        ) {
          const form = document.querySelector('.archive-property__form');
          // archive-property.js toggles data-deployed; fire when opening
          if (form && !form.hasAttribute('data-deployed')) {
            pushEvent({ event: 'open_search_form' });
          }
        }

        // Reset search
        if (target.closest('.archive-property__form__bottom__reset')) {
          pushEvent({ event: 'reset_search_params' });
        }

        // Map / list toggle
        const viewLink = target.closest('.archive-property__form__options a.cta');
        if (viewLink) {
          const href = viewLink.getAttribute('href') || '';
          if (/view_mode=map/.test(href)) {
            pushEvent({ event: 'show_map' });
          } else if (/view_mode=list/.test(href) || /Voir la liste/i.test(viewLink.textContent)) {
            pushEvent({ event: 'show_list' });
          }
        }

        // select_item on property cards (archive / lists)
        const bienLink = target.closest('a.bien-item');
        if (bienLink && config.isPropertyArchive) {
          const item = getItemFromElement(bienLink);
          if (item) {
            const listMeta = config.listMeta || {};
            pushEcommerce('select_item', {
              item_list_id: listMeta.item_list_id || '',
              item_list_name: listMeta.item_list_name || '',
              items: [item],
            });
          }
        }
      },
      true
    );

    // Jobs: dedicated listener to avoid double events
    document.querySelectorAll('.offre-item').forEach((offre) => {
      offre.addEventListener('click', () => {
        const title =
          offre.getAttribute('data-title') ||
          (offre.querySelector('h2, h3, .title') &&
            offre.querySelector('h2, h3, .title').textContent.trim()) ||
          '';
        pushEvent({
          event: 'view_job_posting',
          job_posting: title,
        });
      });
    });
  }

  /* ——— Search form submit ——— */
  function bindSearchForm() {
    const form = document.getElementById('archive-property__form');
    if (!form) return;

    form.addEventListener('submit', () => {
      const collection = [];
      const style = [];
      const wish = [];

      form.querySelectorAll('input[name="collection_filter[]"]:checked').forEach((input) => {
        const label = form.querySelector(`label[for="${  input.id  }"]`);
        collection.push(label ? label.textContent.trim() : input.value);
      });
      form.querySelectorAll('input[name="style_filter[]"]:checked').forEach((input) => {
        const label = form.querySelector(`label[for="${  input.id  }"]`);
        style.push(label ? label.textContent.trim() : input.value);
      });
      form.querySelectorAll('input[name="wish_filter[]"]:checked').forEach((input) => {
        const label = form.querySelector(`label[for="${  input.id  }"]`);
        wish.push(label ? label.textContent.trim() : input.value);
      });

      // Liens collections cochés via data-checked
      form.querySelectorAll('.archive-property__form__filters__section a[data-checked="true"]').forEach(
        (link) => {
          const section = link.closest('.archive-property__form__filters__section');
          const sectionLabel = section && section.querySelector(':scope > label');
          const name = link.textContent.trim();
          if (sectionLabel && /Collections/i.test(sectionLabel.textContent)) {
            collection.push(name);
          } else if (sectionLabel && /Styles/i.test(sectionLabel.textContent)) {
            style.push(name);
          } else if (sectionLabel && /Envies/i.test(sectionLabel.textContent)) {
            wish.push(name);
          }
        }
      );

      const referenceInput = form.querySelector('input[name="reference"]');
      const propertyReference = referenceInput ? referenceInput.value.trim() : '';

      pushEvent({
        event: 'search',
        search_term: propertyReference,
        collection: collection,
        style: style,
        wish: wish,
        property_reference: propertyReference,
      });
    });
  }

  /* ——— CF7 ——— */
  function bindCf7() {
    document.addEventListener(
      'wpcf7mailsent',
      (event) => {
        const formEl = event.target;
        if (formEl && formEl.closest('.aside-footer__newsletter')) {
          pushEvent({ event: 'newsletter_subscribe' });
          return;
        }

        const mapping = resolveFormMapping(event.detail || {});
        fireFormEvents(mapping);
      },
      false
    );
  }

  /* ——— read_post (10s + 70% scroll) ——— */
  function bindReadPost() {
    if (!config.isSinglePost || !config.readPost) return;

    let timed = false;
    let scrolled = false;
    let fired = false;

    function maybeFire() {
      if (fired || !timed || !scrolled) return;
      fired = true;
      pushEvent({
        event: 'read_post',
        post_title: config.readPost.post_title,
        post_category: config.readPost.post_category,
      });
    }

    setTimeout(() => {
      timed = true;
      maybeFire();
    }, 10000);

    function onScroll() {
      const content =
        document.querySelector('.single-post__wrapper .content-style') ||
        document.querySelector('.single-post') ||
        document.querySelector('main.single-post');
      if (!content) return;

      const rect = content.getBoundingClientRect();
      const contentTop = window.scrollY + rect.top;
      const contentHeight = content.offsetHeight;
      const viewportBottom = window.scrollY + window.innerHeight;
      const progress = (viewportBottom - contentTop) / contentHeight;

      if (progress >= 0.7) {
        scrolled = true;
        maybeFire();
        window.removeEventListener('scroll', onScroll);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ——— Complianz ——— */
  function bindComplianz() {
    document.addEventListener(
      'click',
      (event) => {
        const accept = event.target.closest(
          '.cmplz-accept, .cmplz-btn.cmplz-accept, button.cmplz-accept, .cmplz-accept-all, [data-cmplz-varying-accept]'
        );
        if (accept) {
          pushEvent({ event: 'cmp_cookies_allow' });
          return;
        }
        const deny = event.target.closest(
          '.cmplz-deny, .cmplz-btn.cmplz-deny, button.cmplz-deny, .cmplz-deny-all, .cmplz-btn.cmplz-deny-all'
        );
        if (deny) {
          pushEvent({ event: 'cmp_cookies_deny' });
        }
      },
      true
    );
  }

  function init() {
    trackViewItemList();
    trackViewItem();
    trackAlertUpdated();
    bindGlobalClicks();
    bindSearchForm();
    bindCf7();
    bindReadPost();
    bindComplianz();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
